
import {
  WAREHOUSE_SETUP_SELECT_DATABASE,
  WAREHOUSE_SETUP_SELECT_CONNECT_TAB,
  WAREHOUSE_SETUP_ENTER_USERNAME,
  WAREHOUSE_SETUP_ENTER_PASSWORD,
  WAREHOUSE_SETUP_ENTER_HOST,
  WAREHOUSE_SETUP_ENTER_PORT,
  WAREHOUSE_SETUP_ENTER_DATABASE,
  WAREHOUSE_SETUP_ENTER_PROJECT_ID,
  WAREHOUSE_SETUP_ENTER_DATASET_ID,
  WAREHOUSE_SETUP_CONNECT,
  WAREHOUSE_SETUP_CONNECT_ERROR,
  WAREHOUSE_SETUP_CONNECTED,
  WAREHOUSE_SETUP_COMPLETED,
  WAREHOUSE_SETUP_CANCELED,
  WAREHOUSE_SETUP_EDIT_CREDENTIALS,
  WAREHOUSE_SETUP_CHANGE_STEP,

  // from actions/warehouses.js
  CREATING_WAREHOUSE,
  CREATE_WAREHOUSE_ERROR,
  CREATED_WAREHOUSE
} from 'actions'

const initialState = {
  databaseId: '',
  currentStep: 'select',
  connectTab: 'existing',
  areSettingsValid: false,
  isConnecting: false,
  didConnect: false,
  didConnectionFail: false,
  error: null,
  isCreating: false,
  didCreate: false,
  didCreateFail: false,
  failedConnectionAttempts: 0,

  // TODO: this is pretty jank and should be defined in metadata rather than the app...
  settings: { // redshift/postgres
    username: '',
    password: '',
    host: '',
    port: '',
    database: ''
  },
  bigquery: {
    projectId: ''
  }
}

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case WAREHOUSE_SETUP_SELECT_DATABASE:
      return {
        ...state,
        databaseId: payload
      }
    case WAREHOUSE_SETUP_SELECT_CONNECT_TAB:
      return {
        ...state,
        connectTab: payload
      }
    case WAREHOUSE_SETUP_CHANGE_STEP:
      return {
        ...state,
        currentStep: payload
      }

    case WAREHOUSE_SETUP_ENTER_USERNAME:
    case WAREHOUSE_SETUP_ENTER_PASSWORD:
    case WAREHOUSE_SETUP_ENTER_HOST:
    case WAREHOUSE_SETUP_ENTER_PORT:
    case WAREHOUSE_SETUP_ENTER_DATABASE: {
      const nextSettings = settings(state, { type, payload })
      return {
        ...state,
        failedConnectionAttempts: 0, // reset failure count if they edit their credentials
        settings: nextSettings,
        areSettingsValid: areSettingsValid(nextSettings)
      }
    }

    case WAREHOUSE_SETUP_ENTER_PROJECT_ID:
    case WAREHOUSE_SETUP_ENTER_DATASET_ID: {
      const next = bigquery(state, { type, payload })
      return {
        ...state,
        bigquery: next,
        areSettingsValid: areSettingsValid(next, 'bigquery')
      }
    }

    case WAREHOUSE_SETUP_EDIT_CREDENTIALS:
      return {
        ...state,
        isConnecting: false,
        didConnectionFail: false,
        didConnect: false
      }
    case WAREHOUSE_SETUP_CONNECT:
      return {
        ...state,
        isConnecting: true,
        didConnectionFail: false,
        didConnect: false
      }
    case WAREHOUSE_SETUP_CONNECT_ERROR:
      return {
        ...state,
        isConnecting: false,
        didConnectionFail: true,
        didConnect: false,
        error: payload,
        failedConnectionAttempts: state.failedConnectionAttempts + 1
      }
    case WAREHOUSE_SETUP_CONNECTED:
      return {
        ...state,
        isConnecting: false,
        didConnectionFail: false,
        didConnect: true
      }

    case WAREHOUSE_SETUP_CANCELED:
    case WAREHOUSE_SETUP_COMPLETED:
      return { ...initialState }

    case CREATING_WAREHOUSE:
      return {
        ...state,
        isCreating: true,
        didCreate: false,
        didCreateFail: false
      }
    case CREATE_WAREHOUSE_ERROR:
      return {
        ...state,
        isCreating: false,
        didCreate: false,
        didCreateFail: true,
        error: payload.error
      }
    case CREATED_WAREHOUSE:
      return {
        ...state,
        isCreating: false,
        didCreate: true,
        didCreateFail: false
      }
    default:
      return state
  }
}

/**
 * Add bigquery "setting".
 */

function bigquery (state, { type, payload }) {
  switch (type) {
    case WAREHOUSE_SETUP_ENTER_PROJECT_ID:
      return { ...state.bigquery, projectId: payload }
    default:
      return state
  }
}

/**
 * Add "setting".
 */

function settings (state, { type, payload }) {
  switch (type) {
    case WAREHOUSE_SETUP_ENTER_USERNAME:
      return {
        ...state.settings,
        username: payload
      }
    case WAREHOUSE_SETUP_ENTER_PASSWORD:
      return {
        ...state.settings,
        password: payload
      }
    case WAREHOUSE_SETUP_ENTER_HOST:
      return {
        ...state.settings,
        host: payload
      }
    case WAREHOUSE_SETUP_ENTER_PORT:
      return {
        ...state.settings,
        port: parseInt(payload, 10)
      }
    case WAREHOUSE_SETUP_ENTER_DATABASE:
      return {
        ...state.settings,
        database: payload
      }
    default:
      return state
  }
}

function areSettingsValid (settings, key = 'settings') {
  const keys = Object.keys(initialState[key])
  for (let i = 0; i < keys.length; i++) {
    if (!settings[keys[i]]) return false
  }
  return true
}



// WEBPACK FOOTER //
// ./reducers/application/warehouse-setup.js